import * as React from 'react';

import SubscriptionVPropBulletPoints from 'bundles/enroll-modal/components/subscriptions/SubscriptionVPropBulletPoints';
import SubscriptionVPropCDP from 'bundles/enroll-modal/components/subscriptions/SubscriptionVPropCDP';
import SubscriptionVPropSDP from 'bundles/enroll-modal/components/subscriptions/SubscriptionVPropSDP';

import 'css!./__styles__/SubscriptionVProp';

type PropsFromCaller = {
  onSdp: boolean;
};

const SubscriptionVProp = ({ onSdp }: PropsFromCaller) => {
  return (
    <div className="rc-SubscriptionVProp">
      <div className="punch-line">{onSdp ? <SubscriptionVPropSDP /> : <SubscriptionVPropCDP />}</div>
      <SubscriptionVPropBulletPoints />
    </div>
  );
};

export default SubscriptionVProp;
